import BreakpointProps from './BreakpointsProps';

const breakpoints: BreakpointProps = {
  horizontal: {
    xxl: {
      value: 1800,
      get query() {
        return `min-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    xl: {
      value: 1600,
      get query() {
        return `min-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    l: {
      value: 1200,
      get query() {
        return `min-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    m: {
      value: 900,
      get query() {
        return `min-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    s: {
      value: 600,
      get query() {
        return `min-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    xs: {
      value: 480,
      get query() {
        return `min-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    xxs: {
      value: 374,
      get query() {
        return `max-width: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
  },
  vertical: {
    l: {
      value: 900,
      get query() {
        return `min-height: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    m: {
      value: 600,
      get query() {
        return `min-height: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
    s: {
      value: 475,
      get query() {
        return `max-height: ${this.value}px`;
      },
      get mediaQuery() {
        return `@media (${this.query})`;
      },
    },
  },
};

export default breakpoints;
